/**
 * Composant Datetime Input (tag ui:input-datetime)
 *
 * Le tag rend un <input type=hidden name=...> (SEUL champ soumis, au format ISO 8601 avec offset)
 * plus deux champs visibles SANS name : <input type=date> + <input type=time>. Ce module câble les
 * deux visibles sur le caché : à chaque changement, on recombine date + heure (interprétées en heure
 * LOCALE du navigateur) et on réécrit le caché. Date absente -> caché vide -> null côté serveur
 * (brouillon). Sans interaction, le caché garde la valeur rendue par le serveur.
 */
import { logger } from '../../core/base.js';

const pad = (n) => String(n).padStart(2, '0');

/**
 * "YYYY-MM-DD" + "HH:mm" (heure locale) -> "YYYY-MM-DDTHH:mm:00±HH:MM", ou '' si date absente/invalide.
 * L'offset est celui du navigateur À CETTE DATE (getTimezoneOffset est DST-aware), cohérent avec
 * l'heure saisie.
 */
function toIsoOffset(dateStr, timeStr) {
    if (!dateStr) {
        return '';
    }
    const time = timeStr || '00:00';
    const local = new Date(`${dateStr}T${time}:00`); // sans offset => interprété en heure locale
    if (Number.isNaN(local.getTime())) {
        return '';
    }
    const offsetMinutes = -local.getTimezoneOffset(); // ex. Paris été = +120
    const sign = offsetMinutes >= 0 ? '+' : '-';
    const abs = Math.abs(offsetMinutes);
    return `${dateStr}T${time}:00${sign}${pad(Math.floor(abs / 60))}:${pad(abs % 60)}`;
}

/** Initialise les champs datetime (tag ui:input-datetime). */
export function initDatetimeInputs() {
    document.querySelectorAll('.ui-input-datetime').forEach((field) => {
        const hidden = field.querySelector('input[type=hidden]');
        const dateInput = field.querySelector('input[type=date]');
        const timeInput = field.querySelector('input[type=time]');
        if (!hidden || !dateInput || !timeInput) {
            return;
        }

        const sync = () => {
            hidden.value = toIsoOffset(dateInput.value, timeInput.value);
        };
        dateInput.addEventListener('change', sync);
        timeInput.addEventListener('change', sync);
    });

    logger.debug('Datetime inputs initialized');
}

// Auto-initialisation
document.addEventListener('DOMContentLoaded', initDatetimeInputs);
